<template>
  <div class="photofeed">
    <div class='photo-list'>
      <div v-if='photos.length > 0' class='list list-photo' v-for='photo in photosReversed'>
        <div class='thumb eye'  v-bind:style="{ backgroundImage: 'url(' + photo.thumburl + ')' }" v-on:click="$store.dispatch('viewSinglePhoto', photo)"></div>
        <div class='desc'>
          <div class='' v-if="showSpot === 'true'"><div class='blue-circle'></div> <div class='spot-link' v-on:click='popSpot(photo.spot)'> {{photo.spot}}</div> | <span v-if="photo.score">{{photo.score}}/100 poäng | {{photo.voteCount}} röster</span><span v-else>färre än 5 röster</span></div>
          <div class='username' v-if="showUser === 'true'">
            <div class='blue-circle'></div> <div class='spot-link'> {{photo.spot}}</div> av <b>{{photo.username}}</b> <!--{{photo.id}}| <span v-if="photo.score && photo.voteCount > 4">{{photo.score}}/100 poäng | {{photo.voteCount}} röster</span><span v-else>färre än 5 röster</span>--> 
            <div v-if="true === false" style="padding: 3px 15px; background-color: orange; color: #fff; border-radius: 4px; margin-left: 10px; cursor: pointer; display: inline-block" v-on:click="makeSpotWinner(photo)">GÖR TILL VINNARE!!</div>
          </div>
        </div>
      </div>
      <div v-if='photos.length == 0'  class='empty list'>
        <slot name='empty'>Inga foton.</slot>
      </div>
    </div>
  </div>
</template>

<script>
import db from '@/classes/Db'
export default {
  name: 'photoFeed',
  data () {
    return {
      msg: '',
      voted: null
    }
  },
  props: ['photos', 'showUser', 'showSpot'],
  computed: {
    winnerString () {
      return this.photos.map((a, i) => {
        return a.username
      })
    },
    singlePhoto () {
      return this.$store.state.singlePhoto
    },
    photosReversed () {
      let sliced = this.photos.slice()
      let list = sliced.reverse()
      if (this.showUser === 'true') {
        return list
      }
      if (this.showSpot === true) {
        return list
      } else {
        return list.slice(0, 29)
      }
    }
  },
  methods: {
    makeSpotWinner (photo) {
      this.voted = photo.id
      db.database().ref('finalwinners/' + photo.id).set(photo)
    },
    popSpot (name) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.$store.commit('updateSpotAtDistance', name)
    },
    close () {
      this.$store.commit('setSinglePhoto', null)
    }
  },
  mounted () {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .view.par {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 999911;
    background-color: #000;
    color: #fff;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .thumb {
    width: 100%;
    height: 250px;
    background-color: #f4f4f4;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .desc {
    font-size: 16px;
    padding: 10px 20px 10px 20px;
    text-align: left;
  }
  .spot-link {
    color: #2f4efd;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
  }
  .desc .username {
    font-size: 14px;
  }
  .photo-list {
    padding: 10px 0px;
  }
  .list {
    padding: 10px 0px;
    width: 100%;
    box-sizing: border-box;
  }
  @media only screen and (min-width: 600px) {
    .thumb {
      height: 440px;
    }
    .eye {
    }
  }
</style>



// WEBPACK FOOTER //
// photoFeed.vue?16ccf9ab